import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import StartupComponent from './startup/Startup.component';

if (process.env.NODE_ENV === 'development') {
  const logo = `
███╗   ███╗ ███████╗████████╗██╗  ██╗ ██████╗ ██████╗
████╗ ████║ ██╔════╝╚══██╔══╝██║  ██║██╔═══██╗██╔══██╗
██╔████╔██║ █████╗     ██║   ███████║██║   ██║██║  ██║
██║╚██╔╝██║ ██╔══╝     ██║   ██╔══██║██║   ██║██║  ██║
██║ ╚═╝ ██║ ███████╗   ██║   ██║  ██║╚██████╔╝██████╔╝
╚═╝     ╚═╝ ╚══════╝   ╚═╝   ╚═╝  ╚═╝ ╚═════╝ ╚═════╝
`;

  console.log(
    `%c${logo}\n`,
    `
      color: #1976d2;
      font-family: monospace;
      font-weight: 700;
    `
  );
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<StartupComponent />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
